{
  "name": "Permissions",
  "columns": [
    {
      "fieldName": "displayName",
      "displayName": "Name",
      "dataType": "STRING",
      "styleConfig": {
        "styleProperties": {
          "fontWeight": 700
        }
      }
    },
    {
      "fieldName": "description",
      "displayName": "Description",
      "dataType": "STRING"
    }
  ]
}
